export default "__VITE_ASSET__B6inZ2_l__"